// @file pricing.js
import { enPricingPlans, jaPricingPlans } from './pricing-data.js';
const $body = $(document.body);

if($body.hasClass("page--pricing")) {
  let $plus = $("#tab_plus");
  let $team = $("#tab_team");
  let $enterprise = $("#tab_enterprise");
  let $js_pricing__button = $('.js_pricing__button');
  let $js_team_pricing__button = $(".js_team_pricing__button");
  let $js_pricing__section = $('.js_pricing__section');

  let $yearlyPricing = $(".pricing-card__cost-price");
  let $monthlyPricing = $(".pricing-card__details-monthly span:first-child");
  let $users = $(".pricing-card__users-amount span:first-child");
  let planCounter = 0;

  let enterpriseTotalItems = 8;
  let teamTotalItems = 10;

  let $js_teamPricing__buttonPrevious = $('.js_team-pricing__button-previous');
  let $js_teamPricing__buttonNext = $('.js_team-pricing__button-next');

  let $js_enterprisePricing__buttonPrevious = $('.js_enterprise-pricing__button-previous');
  let $js_enterprisePricing__buttonNext = $('.js_enterprise-pricing__button-next');
  let $js_enterprisePricing__buttonQuote = $('.js_enterprise-pricing__button-quote');

  let $jaExtraInfo = $(".pricing-card__ja-info");

  // Get site language
  let language = Cacoo.settings.lang;

  // Get URL hash
  let urlHash = location.hash;

  // PRICING-PLAN A/B testing
  let $pricingPlanIncludes = $('.js_pricing-card__includes-items');
  let $pricingPlanIncludesButton = $('.js_pricing-card__includes-button');
  let $pricingPlanIncludesIcon = $('.pricing-card__includes-icon');

  $pricingPlanIncludesButton.on('click', function () {
    $pricingPlanIncludesIcon.toggleClass('is_open-arrow');
    $pricingPlanIncludes.toggleClass('is_open');
  }); // END PRICING-PLAN A/B testing

  // Hash behavior
  if ( urlHash === '#plus' ) {
    showProductPricing('plus');
  } else if ( urlHash === '#enterprise' ) {
    showProductPricing('enterprise');
  } else {
    // Initiate Typetalk as first pricing option
    showProductPricing('team');
  }

  if (language === "ja") {
    $jaExtraInfo.text ("※価格は税込み表示です");
  }

  // Plus button
  $plus.click(function() {
    showProductPricing('plus');
  });

  // Team button
  $team.click(function() {
    showProductPricing('team');
    planCounter = 0;
  });

  // Enterprise button
  $enterprise.click(function() {
    showProductPricing('enterprise');
    planCounter = 0;
  });

  // Team prev(<) button
  $js_teamPricing__buttonPrevious.click(function(e) {
    e.preventDefault();
    if (planCounter > 0) {
      planCounter--;
      updateTeamPricing(planCounter);
    }
  });

  // Team next(>) button
  $js_teamPricing__buttonNext.click(function(e) {
    e.preventDefault();
    if (planCounter < teamTotalItems) {
        planCounter++;
        updateTeamPricing(planCounter);
    }
  });

  // Enterprise prev(<) button
  $js_enterprisePricing__buttonPrevious.click(function(e) {
    e.preventDefault();
    if (planCounter > 0) {
      planCounter--;
      updateEnterprisePricing(planCounter);
    }
  });

  // Enterprise next(>) button
  $js_enterprisePricing__buttonNext.click(function(e) {
    e.preventDefault();
    if (planCounter < enterpriseTotalItems) {
        planCounter++;
        updateEnterprisePricing(planCounter);
    }
  });

  // Button behavior
  function showProductPricing(name) {
    $js_pricing__button.each(function() {
      // Button highlight color
      if($(this).hasClass('-' + name)) {
        $(this).addClass("is_active");
      } else {
        $(this).removeClass('is_active');
      }
    });

    // Pricing section to display
    $js_pricing__section.each(function() {
      if($(this).hasClass("pricing__" + name)) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

    setPricing(name, language);
  }

  let $faqHeading = $('.faqs-item__content-heading');

  $faqHeading.on("click", (e) => {
    const $pricingPlanFaq = $(e.currentTarget);
    const $pricingPlanFaqsText = $pricingPlanFaq.next();

    let isOpen = $pricingPlanFaqsText.is(':visible');

    if (isOpen) {
      $pricingPlanFaq.removeClass("is_open");
    } else {
      $pricingPlanFaq.addClass("is_open");
    }
    $pricingPlanFaqsText.slideToggle("fast");
  });

  function yearlyPrices (counter, name) {
    if (name === "team") {
      if (language === 'ja') {
        return '<span>' + jaPricingPlans.planPrice.symbol + jaPricingPlans.planPrice.teamPlan[counter].annually + '</span>/月';
      } else {
        return '<span>' + enPricingPlans.planPrice.symbol + enPricingPlans.planPrice.teamPlan[counter].annually + '</span>/mo';
      }
    } else {
      if (language === 'ja') {
        return '<span>' + jaPricingPlans.planPrice.symbol + jaPricingPlans.planPrice.enterprisePlan[counter].annually + '</span>/年';
      } else {
        return '<span>' + enPricingPlans.planPrice.symbol + enPricingPlans.planPrice.enterprisePlan[counter].annually + '</span>/yr';
      }
    }
  }

  function monthlyPrices (counter, name) {
    if (name === "team") {
      if (language === 'ja') {
        return jaPricingPlans.planPrice.symbol + jaPricingPlans.planPrice.teamPlan[counter].monthly;
      } else {
        return enPricingPlans.planPrice.symbol + enPricingPlans.planPrice.teamPlan[counter].monthly;
      }
    } else {
      if (language === 'ja') {
        return jaPricingPlans.planPrice.symbol + jaPricingPlans.planPrice.enterprisePlan[counter].monthly;
      } else {
        return enPricingPlans.planPrice.symbol + enPricingPlans.planPrice.enterprisePlan[counter].monthly;
      }
    }
  }

  function amountUsers (counter, name) {
    if (name === "team") {
      if (language === 'ja') {
        return jaPricingPlans.planPrice.teamPlan[counter].memberLimit;
      } else {
        return enPricingPlans.planPrice.teamPlan[counter].memberLimit;
      }
    } else {
      if (language === 'ja') {
        return jaPricingPlans.planPrice.enterprisePlan[counter].memberLimit;
      } else {
        return enPricingPlans.planPrice.enterprisePlan[counter].memberLimit;
      }
    }
  }

  // Pricing behavior
  function setPricing(name, language) {
    if (name === "plus") {
      $yearlyPricing.html('<span>' + (language === 'ja' ? (jaPricingPlans.planPrice.symbol + jaPricingPlans.planPrice.plusPlan[0].monthly + '</span>/月') : (enPricingPlans.planPrice.symbol + enPricingPlans.planPrice.plusPlan[0].monthly + '</span>/mo')));
    } else if (name === "team") {
      $yearlyPricing.html(yearlyPrices(0, name));
      $monthlyPricing.text(monthlyPrices(0, name));
      $users.text(amountUsers(0, name));
      $js_team_pricing__button.attr("href", "/team/try?planType=cacoo.team3");
    } else {
      $yearlyPricing.html(yearlyPrices(0));
      $users.text(amountUsers(0));
      $js_enterprisePricing__buttonQuote.text("Request Free Trial")
    }
  }

  function updateTeamPricing(planCounter) {
    $yearlyPricing.html(yearlyPrices(planCounter, 'team'));
    $monthlyPricing.text(monthlyPrices(planCounter, 'team'));
    $users.text(amountUsers(planCounter, 'team'));
    $js_team_pricing__button.attr("href", "/team/try?planType=" + enPricingPlans.planPrice.teamPlan[planCounter].planType);
  }

  function updateEnterprisePricing(planCounter) {
    if (planCounter == enterpriseTotalItems) {
      $yearlyPricing.text(language === 'ja' ? jaPricingPlans.planPrice.enterprisePlan[planCounter].annually : enPricingPlans.planPrice.enterprisePlan[planCounter].annually);
      $js_enterprisePricing__buttonQuote.text("Get Quote")
    } else {
      $yearlyPricing.html(yearlyPrices(planCounter));
      $js_enterprisePricing__buttonQuote.text("Request Free Trial")
    }
    $users.text(amountUsers(planCounter));
  }
}

